<template>
  <div>
    <div class="bg-secondary position-relative basic-type teacher">
      <img
        v-if="imageVisible"
        src="@/assets/image/background wave-3.png"
        class="position-absolute teacher-wave"
      />
      <div
        v-if="imageVisible"
        class="wave-mask position-absolute start-0 top-0 w-100 h-100 bg-secondary"
      ></div>
      <div
        class="content container-xl text-primary text-center position-relative"
      >
        <TitleUnderline :title="'名人堂陣容'"></TitleUnderline>
        <p class="text lh-lg">
          聆聽資訊業頂尖高層對市場趨勢的獨到見解，了解科技創新的核心獲得前所未有的行業洞見，
          共同探索未來科技發展的新視野。
        </p>
        <div class="row mt-5">
          <div
            v-for="(item, index) in teacher"
            :key="index"
            class="col-6 col-md-4 col-lg-3 teacher-card mb-5"
          >
            <div class="position-relative">
              <img
                :src="item.image"
                :alt="item.name"
                class="rounded-4 w-100"
              />
              <button
                class="btn btn-lg btn-dark position-absolute top-50 rounded-pill py-2"
                @click="this.$refs.teacherInfo.openTeacherModal(item)"
              >
                講師介紹
              </button>
              <div class="teacher-mask rounded-4 position-absolute top-0 w-100 h-100"></div>
            </div>
            <div class="teacher-title">
              <h5 class="my-3">{{ item.name }}</h5>
              <p class="mb-0">{{ item.title }}</p>
            </div>
          </div>
          <!-- <div class="col-6 col-md-3 mb-5">
            <div class="bg-card rounded-4 d-flex align-items-center">
              <span class="text-light px-3"
                >與零壹一起共同探索未來科技發展的新視野！</span
              >
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <TeacherInfo ref="teacherInfo"></TeacherInfo>
  </div>
</template>

<script>
import TeacherInfo from "./TeacherModal.vue";

import { scrollMixin } from "@/mixins/scrollMixin";

export default {
  components: {
    TeacherInfo,
  },
  mixins: [scrollMixin],
  data() {
    return {
      teacher: [
        {
          name: "楊肇謙",
          title: "趨勢科技大型事業處業務協理",
          image: new URL("@/assets/image/man/man4@2x.jpg", import.meta.url)
            .href,
          modalImg: new URL("@/assets/image/man/man4@2x.png", import.meta.url)
            .href,
          intro: [
            "楊肇謙 Kevin Yang 主要負責趨勢科技台灣區中大型客戶銷售，包含金融業，高科技製造以及政府部門。 當客戶面臨重大威脅時或資安事故，也經常是協助解決事件的主要領導者。",
            "同時Kevin對於協助大型企業，如何有效降低資安風險，導入零信任資安解決方案或雲端架構解決方案等，亦有許多的實務經驗，台灣許多重大的資安活動中，擔任重要講員。",
          ],
        },
        {
          name: "陳仲儒",
          title: "台灣微軟 全球合作夥伴解決方案事業群 總經理",
          image: new URL("@/assets/image/man/man5@2x.jpg", import.meta.url)
            .href,
          modalImg: new URL("@/assets/image/man/man5@2x.png", import.meta.url)
            .href,
          intro: [
            "陳仲儒（Jerry） 是台灣微軟全球合作夥伴解決方案事業群的總經理。帶領業務、行銷、和技術支援部門等團隊持續深耕台灣市場，帶領台灣微軟與台灣合作夥伴緊密合作，共同打造新的產業生態系，協助台灣產業快速數位轉型，進一步與國際接軌。",
            "Jerry 擁有超過三十年以上的資訊服務行業經驗，也在跨領域、跨兩岸的策略管理上有著豐富的實戰經驗。他曾任京東雲副總裁及平安金融科技壹賬通南區總經理，在兩岸行銷傳播領域也有成功經驗。",
          ],
        },
        {
          name: "許宏俊",
          title: "NetApp 技術總監",
          image: new URL("@/assets/image/man/man1@2x.jpg", import.meta.url)
            .href,
          modalImg: new URL("@/assets/image/man/man1@2x.png", import.meta.url)
            .href,
          intro: [
            "許宏俊先生 (Lawrence Hsu) 現任 NetApp 台灣 (香港商凌拓科技股份有限公司) 技術總監，在 IT 領域有超過二十年工作經驗，曾於日立數據，NTT 國際知名公司擔任銷售技術顧問及商業開發經理，擁有 SUN、HDS、Brocade、Oracle、Azure、AWS 及 NetApp 等超過 20 張專業認證。",
            "許先生專長規劃與建置資訊基礎架構、資料儲存系統、雲端架構佈建、虛擬動態資料中心、以及異地備援等，協助企業提升資訊系統之效能與彈性，進而締造公司高績效成長。曾輔導的客戶涵括政府機關、金融業、電信業、電子及傳統產業，為兼具電腦專業技術及產業營運知識的顧問。",
          ],
        },
        {
          name: "康勝閔",
          title: "NVIDIA 解決方案架構經理",
          image: new URL("@/assets/image/man/man2@2x.jpg", import.meta.url)
            .href,
          modalImg: new URL("@/assets/image/man/man2@2x.png", import.meta.url)
            .href,
          intro: [
            "康勝閔為 NVIDIA 解決方案架構經理，帶領 NVIDIA 解決方案架構 (Solutions Architecture) 團隊，負責與客戶和合作夥伴合作，為人工智慧和深度學習、專業視覺化以及高效能運算提供全球最佳的解決方案，專精於 NVIDIA 各項先進解決方案架構規劃，對於高效能運算與人工智慧和深度學習運算架構有深入的研究，並參與相關重要專案架構規劃。",
            "加入 NVIDIA 之前服務於 HP Enterprise，帶領顧問服務團隊，負責資料中心轉型方案規劃，對於高效能運算與先進資料中心規劃，私有雲與公有雲管理方案，資料中心管理自動化，ITIL 服務管理流程有相當深入的研究，期間參與 HP 多個高效能運算相關專案規劃，對於高效能平行運算演算法與架構，高速網路與儲存系統整體規劃，有深入的研究與相關實務經驗。",
          ],
        },
        {
          name: "杜奕瑾",
          title: "Taiwan AI Labs 創辦人",
          image: new URL("@/assets/image/man/man3@2x.jpg", import.meta.url)
            .href,
          modalImg: new URL("@/assets/image/man/man3@2x.png", import.meta.url)
            .href,
          intro: [
            "杜奕瑾為台灣最大 BBS 站「批踢踢」創站站長、台灣人工智慧實驗室創辦人，臺灣人工智慧發展基金會董事長。曾任微軟人工智慧部門亞太區研究總監、美國國家衛生研究院人類基因研究所程式組長。 2017 年自美國返台創立台灣人工智慧實驗室(Taiwan AI Labs)，為亞洲第一個非營利人工智慧研究機構， 鼓勵以開放演算法、原始碼與聯合學習發展國際可信任的研發成果。",
            "打造「以人為本」的智慧生活一直是杜奕瑾的核心關懷，同時他也將此精神落實至台灣人工智慧實驗室的研究項目。目前實驗室耕耘領域跨足智慧健康醫療、智慧城市、觀光交通、金融和人機介面應用等，依循3大使命方向茁壯發展：Innovate AI in Taiwan and for The World, bring technology to meet nature and humanity, and create impacts and improvements for human well-being.",
            "目前杜奕瑾身兼台灣聯合學習產業大聯盟會長、中華電信獨立董事、文化內容策進院董事、亞洲矽谷計劃民間諮詢委員會諮詢委員、數位國家創新經濟推動小組民間諮詢委員等，期望藉由台灣堅強的軟體實力，推動多元AI應用領域，鏈結產學研界打造完善的數位經濟生態系。目標從台灣出發，打造造福全球人類的人工智慧。",
          ],
        },
        // {
        //   name: "張元正",
        //   title: "Nutanix 大中華區董事總經理",
        //   image: new URL("@/assets/image/man/man6@2x.jpg", import.meta.url)
        //     .href,
        //   modalImg: new URL("@/assets/image/man/man6@2x.png", import.meta.url)
        //     .href,
        //   intro: [
        //     "張元正先生(Daniel Chang)自 2021 年任職 Nutanix 香港暨台灣董事總經理。張先生擁有完整資訊工程背景以及網路、資訊安全、雲端系統的豐富行銷策略與業務開發經驗。曾歷任 Blue Coat 大中華區渠道總監暨台灣總經理，帶領團隊跨越鴻溝並精準標靶市場，翻倍業務營收及大幅提升品牌喜好度。",
        //     "之後加入 Palo Alto Networks 職責香港暨台灣董事總經理，期間對內快速組合兩岸專業團隊，同時透過靈活的市場布局，在短短幾年內有效率的奠定在電信、政府、教育、大型企業、高科技製造業等各領域的客戶基礎群，展現傑出的業務領導績效。",
        //     "接著在 Zscaler 擔任大中華區董事總經理，再度成功打造該公司成為雲端安全系統的領導品牌之一。離開 Zscaler 加入 A10，目前被Nutanix延攬繼續致力開拓香港暨台灣兩岸 IT 市場。",
        //   ],
        // },
        {
          name: "馮志良",
          title: "思科臺灣技術長",
          image: new URL("@/assets/image/man/man7@2x.jpg", import.meta.url)
            .href,
          modalImg: new URL("@/assets/image/man/man7@2x.png", import.meta.url)
            .href,
          intro: [
            "馮志良為思科台灣技術長，負責領導優秀且熱情的系統工程團隊，推廣思科的創新技術。",
            "馮志良曾在位於美國加州矽谷的思科總部服務超過10年，替各種不同業務單位的工程研發部門效力。此外，他也曾帶領進階服務組織的技術工程團隊，為跨國企業客戶執行各項客戶活動。",
            "馮志良擁有超過20年科技業界的經驗，且取得2項路由、交換和資安領域的CCIE（Cisco Certified Internetwork Expert）認證。",
          ],
        },
        {
          name: "尤惠生",
          title: "Palo Alto Networks 台灣區總經理",
          image: new URL("@/assets/image/man/man8@2x.jpg", import.meta.url)
            .href,
          modalImg: new URL("@/assets/image/man/man8@2x.png", import.meta.url)
            .href,
          intro: [
            "James Yu 目前擔任 Palo Alto Networks 台灣區總經理一職，負責該公司在台灣的業務推展、客戶服務、策略合作以及通路管理等工作。",
            "擁有超過 18 年 IT 產業經驗，James 擅長於規劃及執行業務策略、同時在營運績效及團隊領導也有傑出表現。此外，也與台灣高科技製造業、電信產業及政府部門的高階 資訊主管建立起信任關係，有助於推動創新科技。",
          ],
        },
      ],
    };
  },
};
</script>

<style lang="scss">
.teacher {
  overflow: hidden;
  z-index: 1;

  .teacher-wave {
    width: 100%;
    height: 660px;
    left: 0;
    top: -17%;
    object-fit: cover;
    z-index: 2;

    @media (max-width: $lg) {
      top: -13%;
    }

    @media (max-width: $md) {
      top: -10%;
    }
  }

  .wave-mask {
    animation: left-to-right 1.5s forwards;
    z-index: 3;
  }

  @keyframes left-to-right {
    from {
      transform: translateX(0%);
    }
    to {
      transform: translateX(100%);
    }
  }

  .content {
    z-index: 4;
  }

  .text {
    font-size: 1.5rem;
  }

  @media (max-width: $md) {
    .text {
      font-size: 0.875rem;
    }
  }
}

.teacher-card {
  &:hover {
    .teacher-mask {
      opacity: 0.4;
    }

    button {
      opacity: 1;
    }
  }

  .teacher-mask {
    background: linear-gradient(to bottom, #4653a1, #3283c2);
    opacity: 0;
    z-index: 5;
    transition: opacity 0.3s ease-in-out;
  }

  button {
    width: 70%;
    transform: translate(-50%, -50%);
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
    z-index: 6;

    &:hover {
      background-color: #3283c2;
      border-color: #3283c2;
    }
  }

  .teacher-title {
    height: 100px;
  }
}

// .bg-card {
//   background: linear-gradient(to bottom, #4653a166, #3283c266);
//   height: 340px;
// }
</style>
